/* import __COLOCATED_TEMPLATE__ from './sq-form-field-with-link.hbs'; */
/**
## SqFormFieldComponent
`sq-form-field-with-link` extends from `sq-form-field` to implement a pretty specific layout that is not directly supported by `sq-form-field`.

Desktop:  [label] | [input          ] [link]

Mobile 1: [label]                     [link]
          [input                           ]

Mobile 2: [label                           ]
          [link-with-a-lot-of-text         ]
          [input                           ]

The link can exist conditionally, but for mobile clients the label and input
must be present. This means that support for noLabel from `sq-form-field` must
be rethought if the component is ever mobilized.

```example
@title Example

@hbs
{{#sq-form-field-with-link label=(t "business.devices.headers.deviceCode")
                           shouldShowLink=shouldShowLink
                           linkAction=(action "resetPassword")
                           linkLabel=(t "business.devices.edit.resetPassword")}}

  {{sq-field-input ...}}
{{/sq-form-field-with-link}}

@controller-properties
{
  shouldShowLink: true,
  actions: {
    resetPassword() {
    }
  }
}
```

### Parameters
@param {String} [label] The text in the label.
@param {String} [innerElementId] Populates the "for" attribute of the label.
@param {Boolean} [shouldShowLink=true] Whether to display the link or not.
@param {String} [linkAction] The action that should be forwarded to the controller when the link is clicked.
@param {String} [linkLabel] Link text.
@param {Component} [linkComponent] The link component to display.


Sass dependencies at: `app/assets/stylesheets/bridgeport/components/form-elements/formfield_formfield-with-link.sass`
 */

import SqFormFieldComponent from '@square/glass-ui/components/sq-form-field';
export default SqFormFieldComponent.extend({
  classNames: 'form-field-with-link',
  shouldShowLink: true,
  actions: {
    linkAction() {
      if (this.linkAction) {
        this.linkAction();
      }
    }
  }
});